<script lang="ts">
  import { RefreshPlayGroups } from "@frontend/userlist";
  import { PlayGroups } from "@frontend/walletapi";
  import { onMount } from "svelte";
  import { playGroupsList } from "@frontend/userlist";
  import AddPlayGroups from "@frontend/Components/AddPlayGroups.svelte";
  import { get } from "svelte/store";
  import Modal from "@frontend/Components/Modal.svelte";
  import { push } from "svelte-spa-router";
  import EditPlayGroupForm from "@frontend/Components/EditPlayGroupForm.svelte";
  import { me } from "@frontend/user";
  import { translate, currentLanguage } from "../Translator";


      let playgroups: PlayGroups[] = [];
      let searchInput: string = "";
      let allplaygroups: PlayGroups[] = [];

      
  function clearSearch() {
    searchInput = '';
  }

      onMount(() => {
        if (!$me) {
          push("/user/Login");
          return;
        }
        (async () => {
          await RefreshPlayGroups();
          // ...otros awaits si necesitas
        })();
    });

    type EditAction = {
    action: "edit",
    groupid: number;
  };

  function dismiss() {
    params = undefined;
    push("#/Groups");
  }

  type AddAction = {
    action: "add"
  };

  type RouteParams =
    EditAction |
    AddAction |
    undefined;
  
  export let params: RouteParams = undefined;
  let selectedGroup: PlayGroups | undefined = undefined;

  $: {
    if ($playGroupsList) {
      allplaygroups = $playGroupsList;
      if (params?.action === "edit") {
        const groupid = Number((params as EditAction).groupid);
        selectedGroup = $playGroupsList.find(group => group.Id === groupid);
        console.log('Params:', params);
        console.log('Grupo encontrado:', selectedGroup);
      }
    }
  }

  $: {
    if (allplaygroups) {
      if (searchInput) {
        playgroups = allplaygroups.filter(group => group.GroupName.toLowerCase().includes(searchInput.toLowerCase()));
      } else {
        playgroups = [...allplaygroups]; // Fix typo: changed to spread operator to create a copy of the array
      }
    }
  }

  function openAddModal() {
    params = { action: "add" };
  }


</script>
{#if params?.action == "add"}
    <Modal dismiss={dismiss}>
      <AddPlayGroups dismiss={dismiss}></AddPlayGroups>
    </Modal>
{/if}

{#if params?.action == "edit"}
<Modal dismiss={dismiss}>
  {#if !selectedGroup}
    <div class="ui negative message">
      <div class="header">Error</div>
      <p>Group not found</p>
    </div>
  {:else}
    <EditPlayGroupForm group={selectedGroup} {dismiss}/>
  {/if}
</Modal>
{/if}





<h1 class="ui centered dividing header">{$translate ('Add play Group')}</h1>


<div class="ui action input">
    <input type="text" bind:value={searchInput} placeholder="Search..." autocomplete="off">
    <button class="ui icon button" on:click={clearSearch}>
      <i class="times icon"></i>
    </button>
  </div>


  <button class="ui green button" on:click={openAddModal}>
    <i class="user plus icon"></i>
    {$translate ('Add play Group')}
  </button> 
<div style="overflow-x: auto;">
    <table class="playerlist ui celled unstackable striped very compact unselectable table">
    <thead>
      <tr>
        <th style="width: 0px">#</th>
        <th>{$translate ('Label')}</th>
        <th>{$translate ('Group Name')}</th>
        <th style="width: 0px">{$translate ('Options')}</th>
      </tr>
    </thead>
    <tbody>
      {#each playgroups as playgroup}
        <tr>
           <td class="numeric">{playgroup.Id}</td>
           <td class="numeric">{playgroup.Label}</td>
           <td class="numeric">{playgroup.GroupName}</td>
          <td>
            <div class="ui icon buttons">
                <a on:click={() => {console.log(playgroup.Id); push(`/Groups/edit/${playgroup.Id}`, { action: "edit", groupid: playgroup.Id })}} class="ui button">
                <i class="edit icon"></i>
              </a>
            </div>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
<style>

</style>
